import React from "react";

const ApiContext = React.createContext(() => {});

export const WithPromises = WrappedComp => props => (
  <ApiContext.Consumer>{promises => <WrappedComp promises={promises} {...props} />}</ApiContext.Consumer>
);

export default ApiContext;
